"use client";

import { ActivityDisplayPreview } from "./previews";

type HotYogaDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function HotYogaDisplay({ data, participants }: HotYogaDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="hot-yoga"
      data={data}
      participants={participants}
    />
  );
}
